const initialState = {
  loading: false,
  payload: null,
  error: null
}

function settingReferralReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_SETTING_REFERRAL_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'GET_SETTING_REFERRAL_SUCCESS':
      return {
        ...state,
        loading: false,
        payload: action.payload
      }

    case 'GET_SETTING_REFERRAL_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default:
      return state
  }
}

export default settingReferralReducer
